// 대시보드 숫자 카드 네 장 — 원칙은 「카드 숫자 = 눌렀을 때 목록 건수」, 맞출 목록이 없으면 링크를 달지 않는다.

import { EMPTY_MARK, formatWon } from "../../lib/format";
import { listHref } from "../list/search";
import { DashboardStats, formatWinRate } from "../quote/dashboard";
import { QUOTE_STATUS_LABEL, QuoteStatus } from "../quote/types";

export interface DashboardKpi {
  key: "sent_open" | "negotiating" | "win_rate" | "won_amount";
  title: string;
  value: string;
  // 금액 카드의 원 단위 숫자(화면은 <Money>) — 건수·비율 카드는 null.
  amount: number | null;
  hint: string;
  // null 이면 누를 수 없는 카드 — 기간·단위가 같은 목록이 없다.
  href: string | null;
  // 누르면 켜지는 견적 목록 칩(건수 카드만) — 제목이 곧 칩 이름이다.
  status: QuoteStatus | null;
}

// 열린 계열의 최신 버전만 거는 목록(?latest=1) — 카드와 같은 openSeriesHeads 로 센다.
export const openQuotesHref = (status: QuoteStatus): string => listHref("/app/quotes", { status, latest: "1" });

// 두 화면의 수주율은 분모가 다르다 — 대시보드는 보낸 견적(누적), 유입 분석은 문의. 이름에 기준을 싣는다.
export const QUOTE_WIN_RATE_TITLE = "견적 수주율(누적)";
export const QUOTE_WIN_RATE_HINT = "보낸 견적 중 수주한 비율";
export const INQUIRY_WIN_RATE_TITLE = "문의 대비 수주율";

export const buildDashboardKpis = (stats: DashboardStats): DashboardKpi[] => [
  {
    key: "sent_open",
    title: QUOTE_STATUS_LABEL.SENT,
    value: `${stats.sent_open}건`,
    amount: null,
    hint: "지금 고객 답을 기다리는 견적",
    href: openQuotesHref("SENT"),
    status: "SENT",
  },
  {
    key: "negotiating",
    title: QUOTE_STATUS_LABEL.NEGOTIATING,
    value: `${stats.negotiating}건`,
    amount: null,
    hint: "지금 고객과 금액·범위를 맞추는 견적",
    href: openQuotesHref("NEGOTIATING"),
    status: "NEGOTIATING",
  },
  {
    key: "win_rate",
    title: QUOTE_WIN_RATE_TITLE,
    value: formatWinRate(stats.win_rate, EMPTY_MARK),
    amount: null,
    hint: `${QUOTE_WIN_RATE_HINT} · 보낸 ${stats.sent_series}건`,
    href: null,
    status: null,
  },
  {
    key: "won_amount",
    title: "이달 수주 금액",
    value: formatWon(stats.won_amount_this_month),
    amount: stats.won_amount_this_month,
    hint: "이달 수주로 결정된 견적 합계",
    href: null,
    status: null,
  },
];
